import cx from 'classnames'

import Image from 'common/components/image'

const NinjaPreview = () => {
  return (
    <div
      className={cx(
        'hidden lg:flex text-sm w-52 mx-4 lg:w-60 lg:text-base lg:mx-8 flex flex-col justify-center items-center text-coolGray-400 font-medium'
      )}
    >
      <div className="w-28 h-28 mb-4 lg:w-32 lg:h-32">
        <Image src="/images/brand-ps-angry-ninja.svg" alt="Empty preview" />
      </div>

      <div className="text-center mt-8">
        “With literacy comes knowledge, and with knowledge comes power."
      </div>
      <div className="mt-4"> Anonymous</div>
    </div>
  )
}

export default NinjaPreview
